import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import styles from "./AboutUsForm.module.css";
import Typography from "@mui/material/Typography";
import { UniversalContext } from "../../../context/UniversalContext/UniversalContext";
import { Button, IconButton, TextField } from "@mui/material";
import { CancelPresentation } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  borderRadius: "1rem",
  boxShadow: "1px 1px 1rem grey",
  p: 4,
  "@media screen and (max-width: 500px)": {
    width: "90%",
  },
};

export default function AboutUsForm() {
  const { aboutUsModal, setAboutUsModal, setAlert } = React.useContext(UniversalContext);
  const [open, setOpen] = React.useState(aboutUsModal);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [buttonVariant, setButtonVariant] = React.useState("disabled");
  const handleClose = () => setAboutUsModal(false);

  React.useEffect(() => {
    if (name && email && message) {
      setButtonVariant("contained");
    } else {
      setButtonVariant("disabled");
    }
  }, [name, email, message]);

  const formSubmitHandler = (e) => {
    e.preventDefault();
    console.log("Form submitted");
    console.log(name, email, message);
    handleClose();
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 6000);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style} className={styles.box}>
          <div className={styles.flexRow}>
            <h2 style={{ fontWeight: "bold" }}>About Us</h2>
            <IconButton
              color="error"
              aria-label="add to shopping cart"
              onClick={handleClose}
            >
              <CancelPresentation />
            </IconButton>
          </div>
          <Typography
            id="transition-modal-description"
            sx={{ mt: 2 }}
            className={styles.flexCol}
          >
            <p>
              Welcome to our platform! We are dedicated to providing information
              and resources on Ayurveda and Homeopathy to help you make informed
              decisions about your health and well-being.
            </p>
            <p>
              Our mission is to bridge the gap between conventional and
              alternative medicine, offering a comprehensive encyclopedia,
              symptom checker, doctor directory, community interaction, recipes
              section, meditation guides, and more.
            </p>
            <p>
              Feel free to reach out to us with any inquiries or feedback. We
              value your input and are here to assist you on your holistic
              health journey.
            </p>
          </Typography>
          <Typography
            id="transition-modal-description"
            sx={{ mt: 2 }}
            className={styles.flexCol}
          >
            <h2 style={{ fontWeight: "bold" }}>Contact Us</h2>
            <form className={styles.form} onSubmit={formSubmitHandler}>
              <TextField
                className={styles.normalInput}
                required
                color="success"
                id="outlined-required"
                label="Name"
                fullWidth
                defaultValue=""
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                className={styles.normalInput}
                type="email"
                color="success"
                required
                id="outlined-required"
                label="Email"
                fullWidth
                defaultValue=""
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                className={styles.normalInput}
                required
                color="success"
                id="outlined-multiline-static"
                label="Message"
                multiline
                rows={4}
                fullWidth
                defaultValue=""
                onChange={(e) => setMessage(e.target.value)}
              />
              <Button
                variant={buttonVariant}
                type="submit"
                size="large"
                color="success"
                className={styles.modalButton}
              >
                Send Message
              </Button>
            </form>
          </Typography>
        </Box>
      </Fade>
    </Modal>
  );
}
